
import { Helmet } from "react-helmet";
import { safeJsonStringify } from "@/lib/utils";

interface ServiceSchemaProps {
  name: string;
  description: string;
  url: string;
  provider?: {
    name?: string;
    url?: string;
  };
  serviceType: string;
  areaServed?: string | string[];
  offers?: {
    price?: string;
    priceCurrency?: string;
    description?: string;
    availability?: string;
  };
  image?: string;
}

export const ServiceSchema = ({
  name,
  description,
  url,
  provider = {
    name: "edgefi",
    url: "https://edgefi.com"
  },
  serviceType,
  areaServed = "Worldwide",
  offers,
  image
}: ServiceSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": name,
    "description": description,
    "url": url.startsWith('http') ? url : `https://edgefi.com${url}`,
    "provider": {
      "@type": "Organization",
      "name": provider.name,
      "url": provider.url
    },
    "serviceType": serviceType,
    "areaServed": areaServed
  };
  
  // Add image if provided
  if (image) {
    schema["image"] = image.startsWith('http') ? image : `https://edgefi.com${image}`;
  }
  
  // Add offers if provided
  if (offers) {
    schema["offers"] = {
      "@type": "Offer",
      ...offers
    };
  }
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {safeJsonStringify(schema)}
      </script>
    </Helmet>
  );
};
